import { ListSortDirection, Sort } from "../../models/api/sort";
import { EmployeeGroupDTO, EmployeeGroupSTO } from "../../models/employee-groups";
import { BaseApiService } from "../base/base-api.service";

export class EmployeeGroupsApiService extends BaseApiService<EmployeeGroupDTO, EmployeeGroupSTO> {
  constructor() {
    super({
      servicePath: "/EmployeeGroups",
      loadItemsPath: "/GetEmployeeGroups",
      saveItemsPath: "/SaveEmployeeGroups",
    });
    this.defaultSort = [
      {
        name: "description",
        direction: ListSortDirection.Ascending,
      } as Sort,
    ];
  }
}
